import {
  GLP1_CONSULTATION_APPOINTMENT_TYPE_ID,
  GLP1_FOLLOW_UP_APPOINTMENT_TYPE_ID,
} from '@web-app/graphql/healthie/queries/get-glp1-org-past-appointments/constants';

export const isGlp1AppointmentType = (
  appointmentTypeId: string | null | undefined,
) =>
  appointmentTypeId === GLP1_CONSULTATION_APPOINTMENT_TYPE_ID ||
  appointmentTypeId === GLP1_FOLLOW_UP_APPOINTMENT_TYPE_ID;

export const isInitialAppointment = (
  appointmentTypeName: string | null | undefined,
) => {
  if (!appointmentTypeName) {
    return false;
  }
  return appointmentTypeName.toLowerCase().startsWith('initial') ?? false;
};

export const isFollowUpAppointment = (
  appointmentTypeName: string | null | undefined,
) => {
  if (!appointmentTypeName) {
    return false;
  }
  return appointmentTypeName.toLowerCase().startsWith('follow') ?? false;
};

export enum STAGE_APPOINTMENT_TYPES {
  INITIAL = '51711',
  FOLLOW_UP = '51712',
}

export enum PROD_APPOINTMENT_TYPES {
  INITIAL = '122252',
  FOLLOW_UP = '122250',
}

export const getTimeLimitMinutes = (
  appointmentTypeId: string | undefined,
): number | null => {
  if (!appointmentTypeId) return null;

  // Staging appointment types
  if (['51711', '242772'].includes(appointmentTypeId)) return 60;
  if (['181585'].includes(appointmentTypeId)) return 40;
  if (['290918'].includes(appointmentTypeId)) return 40;
  if (['51712'].includes(appointmentTypeId)) return 30;

  // Production appointment types
  if (['122252', '304250', '445608', '415208'].includes(appointmentTypeId))
    return 60;
  if (['122249', '304251'].includes(appointmentTypeId)) return 40;
  if (['122250'].includes(appointmentTypeId)) return 40;
  if (['121907'].includes(appointmentTypeId)) return 30;
  if (['398667'].includes(appointmentTypeId)) return 10;
  if (['123125'].includes(appointmentTypeId)) return 50;
  if (['122843', '479530'].includes(appointmentTypeId)) return 60;
  if (['122251'].includes(appointmentTypeId)) return 20;

  return null;
};
